<template>
	<div class="custer-table-form">
		<div class="custer-table-form__tools">
			<h2>选项设置</h2>
			<el-button type="primary" size="mini" @click="onAdd">添加</el-button>
		</div>
		<el-form :model="form" :rules="form.rules" ref="form">
			<table-pagination ref="tableItem" :data="form.tableData" :column="form.column" width="100%" row-key="id" max-height="600">
				<template v-slot:value="{row,$index}">
					<el-form-item 
						:prop="'tableData.' + $index + '.value'" 
						:rules="form.rules.value">
						<el-input
							clearable v-model="row.value" size="mini"
							placeholder="请输入选项code"/>
					</el-form-item>
				</template>
				<template v-slot:label="{row,$index}">
					<el-form-item
						:prop="'tableData.' + $index + '.label'" 
						:rules="form.rules.label">
						<el-input
							clearable v-model="row.label" size="mini"
							placeholder="请输入选项名称"/>
					</el-form-item>
				</template>
				<template v-slot:columnNotNull="{row,$index}">
					<el-form-item>
						 <el-switch v-model="row.columnNotNull" active-value="Y" inactive-value="N" @change="onSwitch(row)"></el-switch>
					</el-form-item>
				</template>
				<template v-slot:action="{row,$index}">
					<div class="operate-inline">
						<el-button type="text" size="small" @click="onDelete($index)">删除</el-button>
					</div>
				</template>
			</table-pagination>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['tableLists','displayMode'],
		watch: {
			'form':{
				handler(val){
					this.$emit("optionsJson",val.tableData)
				},
				deep:true
			},
			'tableLists':{
				handler(val) {
					this.form.tableData = JSON.parse(JSON.stringify(val));
				},
				deep:true
			}
		},
		data(){
			return {
				signNum:0,//是否操作表格
				form: {
					tableData:[],
					column:[
						{ label: "选项code", prop: "value",slotScope:true,width:200},
						{ label: "选项名称", prop: "label",slotScope:true,width:150},
						{ label: "是否是默认值", prop: "columnNotNull",slotScope:true},
						{ label: "操作", prop: "action",slotScope:true,width:50,fixed:'right'},
					],
					rules:{
						value: [{
							required: true,
							message: '请输入字段名称',
							trigger: 'blur'
						}],
						label: [{
							required: true,
							message: '请输入选项名称',
							trigger: 'blur'
						}]
					}
				}
			}
		},
		methods: {
			onAdd() {
				this.signNum = Math.random();
				if(this.form.tableData.length == 0) {
					this.form.tableData.push({
						value:'',
						columnNotNull:'N',
						label:''
					})
				}else {
					 this.$refs['form'].validate((valid) => {
						 if(valid){
							this.form.tableData.push({
								value:'',
								columnNotNull:'N',
								label:''
							})
						 }
					 })
				}
				this.initDrag()
			},
			onDelete(index){
				this.signNum = Math.random();
				this.form.tableData.splice(index, 1);
			},
			// 行拖拽
			initDrag(){
				let that= this;
				const tbody = this.$refs.tableItem.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0] // table
				let sortAble = Sortable.create(tbody,{
					animation: 150,
					onEnd:(evt) => {
						const currRow = this.form.tableData.splice(evt.oldIndex, 1)[0]
						this.form.tableData.splice(evt.newIndex, 0, currRow);
						this.signNum = Math.random();
					}
				})
			},
			onSwitch(row){
				if(this.displayMode == 'radio'){
					let arrs = [];
					for(let i in this.form.tableData) {
						if(this.form.tableData[i].columnNotNull == 'Y'){
							arrs.push(this.form.tableData[i])
						}
					}
					if(arrs.length > 1) {
						row.columnNotNull = 'N';
						this.$message.error("单选只能设置一个默认值")
					}
				}
				
			}
		},
	}
</script>

<style lang="scss" scoped>
	.custer-table-form {
		width: 100%;
		h2 {
			font-size: 14px;
			color: #606266;
			padding-left: 5px;
		}
		&__tools {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
		}
	}
</style>
